import * as RadixTooltip from '@radix-ui/react-tooltip';
import * as React from 'react';

import { cn } from '../../lib/utils';

export function TooltipProvider({ children, delayDuration = 400 }: { children: React.ReactNode; delayDuration?: number }) {
  return (
    <RadixTooltip.Provider delayDuration={delayDuration}>
      {children}
    </RadixTooltip.Provider>
  );
}

export const TooltipRoot    = RadixTooltip.Root;
export const TooltipTrigger = RadixTooltip.Trigger;

export const TooltipContent = React.forwardRef<
  React.ElementRef<typeof RadixTooltip.Content>,
  React.ComponentPropsWithoutRef<typeof RadixTooltip.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <RadixTooltip.Portal>
    <RadixTooltip.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        'z-50 overflow-hidden rounded-md border border-border-subtle bg-bg-emphasis px-2.5 py-1.5 text-xs text-text-primary shadow-sm',
        'animate-in fade-in zoom-in-95 duration-fast',
        className,
      )}
      {...props}
    />
  </RadixTooltip.Portal>
));
TooltipContent.displayName = RadixTooltip.Content.displayName;

// Convenience wrapper
interface TooltipProps {
  content: React.ReactNode;
  children: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  delayDuration?: number;
}

export function Tooltip({ content, children, side = 'top', delayDuration }: TooltipProps) {
  return (
    <RadixTooltip.Provider delayDuration={delayDuration ?? 400}>
      <TooltipRoot>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side={side}>{content}</TooltipContent>
      </TooltipRoot>
    </RadixTooltip.Provider>
  );
}
